/**
 * Maps timezone strings to their most likely country codes
 * This is a best-effort mapping as some timezones cover multiple countries
 */
export const TIMEZONE_TO_COUNTRY: Record<string, string> = {
  // Europe
  "Europe/London": "GB",
  "Europe/Dublin": "IE",
  "Europe/Paris": "FR",
  "Europe/Brussels": "BE",
  "Europe/Amsterdam": "NL",
  "Europe/Berlin": "DE",
  "Europe/Vienna": "AT",
  "Europe/Zurich": "CH",
  "Europe/Rome": "IT",
  "Europe/Madrid": "ES",
  "Europe/Lisbon": "PT",
  "Europe/Athens": "GR",
  "Europe/Istanbul": "TR",
  "Europe/Moscow": "RU",
  "Europe/Warsaw": "PL",
  "Europe/Prague": "CZ",
  "Europe/Budapest": "HU",
  "Europe/Copenhagen": "DK",
  "Europe/Stockholm": "SE",
  "Europe/Oslo": "NO",
  "Europe/Helsinki": "FI",
  "Europe/Bucharest": "RO",
  "Europe/Sofia": "BG",
  "Europe/Belgrade": "RS",
  "Europe/Zagreb": "HR",
  "Europe/Ljubljana": "SI",
  "Europe/Tallinn": "EE",
  "Europe/Riga": "LV",
  "Europe/Vilnius": "LT",
  "Europe/Luxembourg": "LU",
  "Europe/Malta": "MT",
  "Europe/Kiev": "UA",
  "Europe/Minsk": "BY",
  "Europe/Reykjavik": "IS",

  // Americas
  "America/New_York": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Los_Angeles": "US",
  "America/Phoenix": "US",
  "America/Anchorage": "US",
  "America/Honolulu": "US",
  "America/Toronto": "CA",
  "America/Vancouver": "CA",
  "America/Edmonton": "CA",
  "America/Winnipeg": "CA",
  "America/Halifax": "CA",
  "America/Mexico_City": "MX",
  "America/Cancun": "MX",
  "America/Tijuana": "MX",
  "America/Sao_Paulo": "BR",
  "America/Rio_de_Janeiro": "BR",
  "America/Buenos_Aires": "AR",
  "America/Santiago": "CL",
  "America/Lima": "PE",
  "America/Bogota": "CO",
  "America/Caracas": "VE",
  "America/La_Paz": "BO",
  "America/Montevideo": "UY",
  "America/Asuncion": "PY",
  "America/Guayaquil": "EC",
  "America/Panama": "PA",
  "America/Costa_Rica": "CR",
  "America/Guatemala": "GT",
  "America/El_Salvador": "SV",
  "America/Tegucigalpa": "HN",
  "America/Managua": "NI",
  "America/Jamaica": "JM",
  "America/Santo_Domingo": "DO",
  "America/Port-au-Prince": "HT",
  "America/Havana": "CU",

  // Asia
  "Asia/Tokyo": "JP",
  "Asia/Shanghai": "CN",
  "Asia/Hong_Kong": "HK",
  "Asia/Singapore": "SG",
  "Asia/Seoul": "KR",
  "Asia/Bangkok": "TH",
  "Asia/Jakarta": "ID",
  "Asia/Manila": "PH",
  "Asia/Kuala_Lumpur": "MY",
  "Asia/Ho_Chi_Minh": "VN",
  "Asia/Yangon": "MM",
  "Asia/Dhaka": "BD",
  "Asia/Colombo": "LK",
  "Asia/Kathmandu": "NP",
  "Asia/Kolkata": "IN",
  "Asia/Mumbai": "IN",
  "Asia/Delhi": "IN",
  "Asia/Karachi": "PK",
  "Asia/Tehran": "IR",
  "Asia/Baghdad": "IQ",
  "Asia/Riyadh": "SA",
  "Asia/Dubai": "AE",
  "Asia/Kuwait": "KW",
  "Asia/Doha": "QA",
  "Asia/Bahrain": "BH",
  "Asia/Jerusalem": "IL",
  "Asia/Beirut": "LB",
  "Asia/Damascus": "SY",
  "Asia/Amman": "JO",
  "Asia/Ankara": "TR",
  "Asia/Baku": "AZ",
  "Asia/Tbilisi": "GE",
  "Asia/Yerevan": "AM",
  "Asia/Almaty": "KZ",
  "Asia/Tashkent": "UZ",
  "Asia/Bishkek": "KG",
  "Asia/Dushanbe": "TJ",
  "Asia/Ashgabat": "TM",
  "Asia/Kabul": "AF",
  "Asia/Ulaanbaatar": "MN",
  "Asia/Pyongyang": "KP",

  // Africa
  "Africa/Cairo": "EG",
  "Africa/Lagos": "NG",
  "Africa/Johannesburg": "ZA",
  "Africa/Cape_Town": "ZA",
  "Africa/Nairobi": "KE",
  "Africa/Addis_Ababa": "ET",
  "Africa/Dar_es_Salaam": "TZ",
  "Africa/Kampala": "UG",
  "Africa/Khartoum": "SD",
  "Africa/Algiers": "DZ",
  "Africa/Tunis": "TN",
  "Africa/Tripoli": "LY",
  "Africa/Casablanca": "MA",
  "Africa/Rabat": "MA",
  "Africa/Dakar": "SN",
  "Africa/Abidjan": "CI",
  "Africa/Accra": "GH",
  "Africa/Kinshasa": "CD",
  "Africa/Luanda": "AO",
  "Africa/Harare": "ZW",
  "Africa/Lusaka": "ZM",
  "Africa/Maputo": "MZ",
  "Africa/Windhoek": "NA",
  "Africa/Gaborone": "BW",

  // Oceania
  "Australia/Sydney": "AU",
  "Australia/Melbourne": "AU",
  "Australia/Brisbane": "AU",
  "Australia/Perth": "AU",
  "Australia/Adelaide": "AU",
  "Australia/Darwin": "AU",
  "Australia/Hobart": "AU",
  "Pacific/Auckland": "NZ",
  "Pacific/Wellington": "NZ",
  "Pacific/Fiji": "FJ",
  "Pacific/Port_Moresby": "PG",
  "Pacific/Noumea": "NC",
  "Pacific/Tahiti": "PF",
  "Pacific/Guam": "GU",
  "Pacific/Honolulu": "US",

  // Atlantic
  "Atlantic/Reykjavik": "IS",
  "Atlantic/Azores": "PT",
  "Atlantic/Canary": "ES",
  "Atlantic/Bermuda": "BM",

  // Indian Ocean
  "Indian/Mauritius": "MU",
  "Indian/Reunion": "RE",
  "Indian/Maldives": "MV",
  "Indian/Seychelles": "SC",

  // UTC/GMT
  "UTC": "GB",
  "GMT": "GB",
  "GMT+0": "GB",
  "GMT-0": "GB",
  "Etc/GMT": "GB",
  "Etc/UTC": "GB",
};

/**
 * Get country code from timezone string
 * @param timezone - IANA timezone string (e.g., "Europe/London")
 * @returns Country code (e.g., "GB") or null if not found
 */
export function getCountryFromTimezone(timezone: string | null | undefined): string | null {
  if (!timezone) return null;

  // Direct lookup
  if (TIMEZONE_TO_COUNTRY[timezone]) {
    return TIMEZONE_TO_COUNTRY[timezone];
  }

  // Try to match partial timezone (e.g., if timezone includes additional info)
  const cleanedTimezone = timezone.split(' ')[0]; // Handle cases like "Europe/London GMT"
  if (TIMEZONE_TO_COUNTRY[cleanedTimezone]) {
    return TIMEZONE_TO_COUNTRY[cleanedTimezone];
  }

  // Try to extract continent/city pattern
  const parts = timezone.split('/');
  if (parts.length === 2) {
    const normalizedTimezone = `${parts[0]}/${parts[1].split(' ')[0]}`;
    if (TIMEZONE_TO_COUNTRY[normalizedTimezone]) {
      return TIMEZONE_TO_COUNTRY[normalizedTimezone];
    }
  }

  return null;
}

/**
 * Get default country code based on timezone, with fallback
 * @param timezone - IANA timezone string
 * @param fallback - Fallback country code (default: "US")
 * @returns Country code
 */
export function getDefaultCountryFromTimezone(
  timezone: string | null | undefined,
  fallback: string = "US"
): string {
  const country = getCountryFromTimezone(timezone);
  return country || fallback;
}